import { useState } from "react";
import resultArrayToMbti from "../utils/resultArrayToMbti";
import mbtiToResultArray from "../utils/mbtiToResultArray";
import { Col, Container, Row } from "react-bootstrap";

function InputPage({setCurrentPage, currentPage, testResults, setTestResults, currentQuestion, setCurrentQuestion }) {

    const [inputValue, setInputValue] = useState("");

    const onClick = () => {
        const result = mbtiToResultArray(inputValue);
        if (!result) {
            console.error("Invalid MBTI input");
            setCurrentPage(() => currentPage + 1)
            return;
        }
        setTestResults(result)
        
        console.log("Input submitted");
        setCurrentPage(() => currentPage + 2);
    };
    const handleInputChange = (event) => {
        setInputValue(event.target.value);
        
    };

    return (
            <div className="background-image" style={{ backgroundImage: `url(/images/background-1.png)` }}>
                <Container>
                    <Row className="justify-content-md-center">
                        <Col className="title-row">
                            <h1>是否測過 MBTI 測驗？</h1>
                        </Col>
                    </Row>
                    <Row className="justify-content-md-center">
                        <Col>
                            <input
                                type="text"
                                value={inputValue}
                                onChange={handleInputChange}
                                placeholder="輸入你的 MBTI 人格"
                                style={{ width: "300px", padding: "10px", fontSize: "16pt", backgroundColor: "#9CD3A0", border: "1px solid #256143", borderRadius: "5px" }}
                            />
                        </Col>
                    </Row>
                    <Row className="justify-content-md-center">
                        <Col>
                            <p style={{ fontSize: "16pt", textAlign: "center", padding: "20px", color: "#256143" }}>
                                是的話輸入你的 MBTI 人格（四個英文字母）<br />
                                否的話留空即可
                            </p>
                        </Col>
                    </Row>
                    <Row className="justify-content-md-center">
                        <Col>
                            <button onClick={onClick} style={{ padding: "10px 20px", fontSize: "24pt", backgroundColor: "#3C6C3B", border: "1px solid #256143", borderRadius: "5px", color: "white" }}>
                                開始
                            </button>
                        </Col>
                    </Row>
                    <Row className="justify-content-md-center">
                        <Col>
                            <img src="/images/question.png" className="explorer" alt="explorer" />
                        </Col>
                    </Row>
                </Container>
            </div>
    );
}

export default InputPage;